<template>
  <LayoutDefault>
    <section class="container">
      <div class="content">
        <h1 class="cookies-title">{{ $t("cookies.policy.title") }}</h1>
        <div class="text" v-for="i in [0, 1, 2, 3]">

          <h2>{{ $t("cookies.policy." + i + ".title") }}</h2>
          <p>{{ $t("cookies.policy." + i + ".text") }}</p>

          <template 
            v-if="$t('cookies.policy.' + i + '.elem') !== 'cookies.policy.' + i + '.elem'" 
            v-for="elem in $t('cookies.policy.' + i + '.elem')"
          >
            <li>{{ elem }}</li>
          </template>
        </div>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
    import LayoutDefault from "../layouts/LayoutDefault";
    export default {
      components: {LayoutDefault}
    }
</script>

<style scoped lang="scss">
  @import './../styles/variables';

  .container{
    background-color: #000000;
    color: #ffffff;
    min-height: 650px;
    padding: 60px;

    @media(max-width: 350px) {
      padding: 15px;
    }

    @media(max-width: 960px){
      //background-position: left bottom;
      border-bottom: 2px solid var(--pallete_main_color);
    }

    .content{
      align-self: end;
      flex-basis: 50%;
      text-align: left;

      @media(max-width: 960px){
        flex-basis: 100%;
        margin-bottom: 70vw;
      }

      .cookies-title{
        font-size: 2.5em;
        font-weight: bolder;
        margin-bottom: 1em;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
</style>
